import { useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { InfoOutlined } from '@mui/icons-material'
import { toast } from 'react-toastify'

import { get } from 'services/api'
import ResumeTable from 'components/ResumeTable'
import { Pagination } from 'components'
import SearchBar from 'components/SearchBar'
import { homeParams } from 'utils/constants/searchParams'
import styles from './styles'
import ExportButton from "../../components/ExportButton"
import { REPORT_TYPE as REPORT_TYPES } from "../../utils/constants/reportType"

const Home = () => {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)

  const [loading, setLoading] = useState(true)
  const [exportRequested, setExportRequested] = useState(false)
  const [applications, setApplications] = useState(null)
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [pagesNumber, setPagesNumber] = useState(1)
  const [searchParams, setSearchParams] = useState(homeParams)

  const getData = () => {
    setLoading(true)
    const currentPage = page + 1
    get({
      url: `/applications/list/paginated`,
      token,
      params: {
        page: currentPage,
        size: size,
        ...searchParams,
      },
    })
      .then((response) => {
        const { data } = response
        setApplications(data?.items)
        setPagesNumber(data?.total)
      })
      .catch(() => {
        toast.error('Houve um erro ao carregar os dados')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handlePageChange = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value)
    setPage(0)
  }

  const handleChangeSearchParams = (value) => {
    setSearchParams(value)
  }
  const reloadData = () => {
    getData()
  }

  useEffect(() => {
    setExportRequested(false)
  }, [searchParams])

  useEffect(() => {
    reloadData()
  }, [page, size, searchParams])

  return (
    <div className={classes.root}>
      <div className={classes.topBar}>
        <SearchBar setSearchParams={handleChangeSearchParams} />
        <ExportButton
          reportType={REPORT_TYPES.APPLICATION}
          searchParams={searchParams}
          disabled={exportRequested}
          setExportRequested={setExportRequested}
        />
      </div>

      {loading ? (
        <div className={classes.loading}>
          <CircularProgress size={64} color="primary" />
          <span className={classes.loadingText}>Buscando aplicações...</span>
        </div>
      ) : (
        <React.Fragment>
          <div className={classes.tableContainer}>
            {applications ? (
              <ResumeTable data={applications} />
            ) : (
              loading ? <div /> : (
                <div className={classes.noData}>
                <span>
                  <InfoOutlined fontSize="inherit" />
                </span>
                  <span>Nenhum registro encontrado</span>
                </div>)
            )}
          </div>

          <Pagination
            count={pagesNumber}
            component="div"
            page={page}
            rowsPerPage={size}
            rowsPerPageOptions={[10, 15, 20, 25, 30]}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </React.Fragment>
      )}
    </div>
  )
}

export default Home
